export default __webpack_public_path__ + "static/media/nitro-ion.b8651533.png";